import { useQuery } from '@tanstack/react-query';
import { TaskEquipment, TaskEquipmentSummary } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const TASK_EQUIPMENTS_QUERY_KEY = ['taskEquipments'];

export const useTaskEquipments = (taskId: string | undefined) => {
  return useQuery<TaskEquipment[], Error>({
    queryKey: [...TASK_EQUIPMENTS_QUERY_KEY, taskId],
    queryFn: async () => {
      if (!taskId) throw new Error('taskId is required');
      return await warehouseService.getTaskEquipments(taskId);
    },
    enabled: !!taskId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

export const useTaskEquipmentSummary = (taskId: string | undefined) => {
  return useQuery<TaskEquipmentSummary, Error>({
    queryKey: [...TASK_EQUIPMENTS_QUERY_KEY, taskId, 'summary'],
    queryFn: async () => {
      if (!taskId) throw new Error('taskId is required');
      return await warehouseService.getTaskEquipmentSummary(taskId);
    },
    enabled: !!taskId,
    staleTime: 2 * 60 * 1000,
  });
};
